import { SUBSCRIPTION_CONTRACT_META_KEY } from "../constants.js";
/**
 * Builds the contract meta for a holdback (pause).
 *
 * - `dispatchBatchCode` points at the chosen dispatch, so the member gets that
 *   dispatch when the pause ends and dispatch date changes follow it.
 * - `periodsToSkip` is removed, so a pending skip does not swallow the chosen
 *   dispatch.
 * - `holdbackUntil` marks the pause until the chosen dispatch.
 * - `bindingPeriodStartedAt` is set to `now`, as a new binding period starts
 *   when the holdback is registered.
 * - All other meta is kept, since the meta array replaces the whole meta.
 */
export const buildHoldbackMeta = (meta, { dispatchBatchCode, holdbackUntil, }, now = new Date()) => {
    const replacedKeys = [
        SUBSCRIPTION_CONTRACT_META_KEY.DISPATCH_BATCH_CODE,
        SUBSCRIPTION_CONTRACT_META_KEY.PERIODS_TO_SKIP,
        SUBSCRIPTION_CONTRACT_META_KEY.HOLDBACK_UNTIL,
        SUBSCRIPTION_CONTRACT_META_KEY.BINDING_PERIOD_STARTED_AT,
    ];
    return [
        ...(meta ?? []).filter(({ key }) => !replacedKeys.includes(key)),
        {
            key: SUBSCRIPTION_CONTRACT_META_KEY.DISPATCH_BATCH_CODE,
            value: dispatchBatchCode,
        },
        {
            key: SUBSCRIPTION_CONTRACT_META_KEY.HOLDBACK_UNTIL,
            value: holdbackUntil,
        },
        {
            key: SUBSCRIPTION_CONTRACT_META_KEY.BINDING_PERIOD_STARTED_AT,
            value: now.toISOString(),
        },
    ];
};
